var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.023 16H61.8047C61.8047 27.52 71.1287 36.848 82.6517 36.848H91.1517V45.074C91.1517 56.594 100.48 65.922 112 65.922V19.977C111.999 18.9225 111.58 17.9114 110.834 17.1657C110.088 16.4201 109.077 16.0008 108.023 16Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1213 39.04H38.9023C38.9023 50.559 48.2273 59.887 59.7463 59.887H68.2503V68.113C68.2503 79.633 77.5783 88.961 89.0983 88.961V43.016C89.0968 41.9617 88.6772 40.9511 87.9318 40.2056C87.1863 39.4601 86.1756 39.0416 85.1213 39.04Z",
    fill: "url(#paint0_linear_17_110)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.219 62.078H16C16 73.602 25.324 82.926 36.848 82.926H45.348V91.156C45.348 102.676 54.676 112 66.195 112V66.059C66.1939 65.0045 65.7748 63.9934 65.0295 63.2473C64.2842 62.5012 63.2735 62.0801 62.219 62.078Z",
    fill: "url(#paint1_linear_17_110)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_110",
    x1: 88.1363,
    y1: 39.092,
    x2: 68.4723,
    y2: 59.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_110",
    x1: 66.564,
    y1: 62.256,
    x2: 43.828,
    y2: 84.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.62bacc7a173caa759beb778d760b96fe.svg";
export { ForwardRef as ReactComponent };